import { render, staticRenderFns } from "./PaymentsConfigurationForm.vue?vue&type=template&id=4729eb2c&"
import script from "./PaymentsConfigurationForm.vue?vue&type=script&lang=js&"
export * from "./PaymentsConfigurationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports